import { assignStudioQuery } from '.';
import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType } from '../../model';
import { IDrawHistoryItem } from '../../model/billing-center/withdrawal';
import { BILLING_PROXY_VIEW } from '../config';

// 提现记录-列表
export const getDrawHistoryList = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(
        `${BILLING_PROXY_VIEW}/api/account/draw_history`
      );
      const response = await api.commonRequest('GET', url, {
        studio_id: studioId,
        page: 1,
        size: 9999,
      });
      const res = await parsedResponse<IDrawHistoryItem>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: getDrawHistoryList', error);
      return null;
    }
  });

// 提现
export const putDrawMoney = (
  studioId: string,
  amount: string,
  draw_creator: string
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(`${BILLING_PROXY_VIEW}/api/account/draw`);
      const response = await api.commonRequest('POST', url, {
        studio_id: studioId,
        amount,
        draw_creator,
      });
      const res = await parsedResponse<IDrawHistoryItem>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: putDrawMoney', error);
      return null;
    }
  });
